<template>
    <v-card class="pa-4">

        <v-dialog v-model="showValidationDialog">
            <v-card class="search-modal">
                <h2>Validation Results</h2>
                <v-form class="search-form">
                    <v-alert v-if="!!validationResult && !!validationResult.errors && validationResult.errors.length > 0" type="error">
                        <pre>{{ validationResult.errors.join("\r\n") }}</pre>
                    </v-alert>
                    <v-alert v-if="!!validationResult && validationResult.warnings && validationResult.warnings.length > 0" type="warning" outlined>
                        <pre>{{ validationResult.warnings.join("\r\n") }}</pre>
                    </v-alert>
                    <v-btn large
                           color="primary"
                           width="125px"
                           :disabled="!validationResult.canBeSaved"
                           v-on:click="saveChanges">
                        <v-icon v-if="!validationResult.canBeSaved">mdi-alert</v-icon>
                        Save
                    </v-btn>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="searchAffiliateDialog" width="800px">
            <v-overlay :value="isLoading">
                <v-progress-circular indeterminate
                                     color="primary"
                                     :size="70"
                                     :width="7"></v-progress-circular>
            </v-overlay>
            <v-card class="search-modal">
                <h2 class="mb-3">Affiliate Search </h2>
                <v-form @submit.prevent="search">
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsAffiliate.affiliateId"
                                          label="Affiliate ID" />
                        </v-col>

                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsAffiliate.state"
                                          label="Home State" />
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsAffiliate.affiliateName"
                                          label="Affiliate Name" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-checkbox v-model="searchParamsAffiliate.membershipStatus" dense label="Show Active Only" class="text-xs"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox v-model="applyPointSchedule" dense label="Apply Point Schedule"></v-checkbox>
                        </v-col>
                        <v-col>


                            <v-btn v-on:click="clearSearchAffiliate" color="primary" class="mr-2">
                                <v-icon> mdi-clear </v-icon>
                                Clear
                            </v-btn>
                            <v-btn v-on:click="searchAffiliate" color="primary">
                                <v-icon> mdi-magnify </v-icon>
                                Search
                            </v-btn>

                        </v-col>
                    </v-row>
                </v-form>
                <v-divider class="my-3"></v-divider>
                <p v-if="searchAffiliateResults.totalCount == 0 && hasSearchAffiliates">
                    No Matching Affiliates Found
                </p>
                <v-data-table v-if="searchAffiliateResults.totalCount > 0"
                              :headers="searchAffiliatesHeaders"
                              :items="searchAffiliateResults.data"
                              hide-default-header
                              hide-default-footer>
                    <template v-slot:item="row">
                        <tr>
                            <td>
                                <a :href="`/admin/affiliates/${row.item.affiliateId}`" target="_blank">
                                    {{row.item.affiliateId}}
                                </a>
                            </td>
                            <td>
                                <a :href="`/admin/affiliates/${row.item.affiliateId}`" target="_blank">
                                    {{ row.item.affiliateName }}
                                </a>
                            </td>
                            <td>
                                {{row.item.state}}
                            </td>
                            <td>
                                <span>
                                    <v-chip v-if="row.item.membershipExpiryDate"
                                            class="my-2"
                                            :color="isExpired(row.item.membershipExpiryDate) ? 'red' : 'green'"
                                            text-color="white">
                                        <v-avatar left>
                                            <v-icon v-if="isExpired(row.item.membershipExpiryDate)">mdi-close-circle-outline</v-icon>
                                            <v-icon v-else>mdi-checkbox-marked-circle</v-icon>
                                        </v-avatar>
                                        {{isExpired(row.item.membershipExpiryDate) ? "Expired" : "Active"}}
                                    </v-chip>
                                </span>

                            </td>
                            <td>


                                <v-btn class="ml-1 mr-1"
                                       color="primary"
                                       @click="affiliateSelect(row.item)">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>

        <v-dialog v-model="searchPersonDialog" width="800px">
            <v-overlay :value="isLoading">
                <v-progress-circular indeterminate
                                     color="primary"
                                     :size="70"
                                     :width="7"></v-progress-circular>
            </v-overlay>
            <v-card class="search-modal">
                <h2 class="mb-3">Event People Search </h2>
                <v-form @submit.prevent="search">
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsPerson.judgeId"
                                          label="Judge ID" />
                        </v-col>

                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsPerson.memberId"
                                          label="Member ID" />
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense
                                          v-model="searchParamsPerson.name"
                                          label="Name" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-xs">
                            <v-checkbox v-model="searchParamsPerson.activeMembersOnly" label="Show Active Only" class="text-xs"></v-checkbox>
                        </v-col>


                        <v-col>


                            <v-btn v-on:click="clearSearchPerson" color="primary" class="mr-2">
                                <v-icon> mdi-clear </v-icon>
                                Clear
                            </v-btn>

                            <v-btn v-on:click="searchPerson" color="primary">
                                <v-icon> mdi-magnify </v-icon>
                                Search
                            </v-btn>

                        </v-col>
                    </v-row>
                </v-form>
                <v-divider class="my-3"></v-divider>
                <p v-if="searchPersonResults.totalCount == 0 && hasSearchPerson">
                    No Matches Found
                </p>
                <v-data-table v-if="searchPersonResults.totalCount > 0"
                              :headers="searchPersonHeaders"
                              :items="searchPersonResults.data"
                              hide-default-footer>

                    <template v-slot:item="row">

                        <tr>
                            <td>
                                <a :href="`/admin/judges/${row.item.judgeId}`" target="_blank" v-if="row.item.judgeId">
                                    {{row.item.judgeId}}
                                </a>
                            </td>
                            <td>
                                <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                    {{row.item.memberId}}
                                </a>

                            </td>
                            <td>
                                <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                    {{ row.item.name }}
                                </a>
                            </td>


                            <td>
                                <font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                            </td>
                            <td>


                                <v-btn class="ml-1 mr-1"
                                       color="primary"
                                       @click="personSelect(row.item)">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>

        <v-row v-if="!badShowData" class="mt-1">
            <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
            <v-textarea :disabled="!isEditMode"
                        :visible="!isEditMode"
                        outlined dense
                        auto-grow
                        clearable
                        rows="1"
                        v-model="showInfo.adminNotes"
                        label="Description of changes (optional)" />
            <v-btn class="ml-1 mr-1"
                   color="primary"
                   @click="toggleEditMode">
                {{ isEditMode ? "Save" : "Edit" }}
            </v-btn>
        </v-row>
        <v-row>

            <v-col>
                <v-card class="pa-2" elevation="2">
                    <v-card-title class="text-h6">
                        Show Dates &amp; Type
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <DatepickerFormatted :disabled="!isEditMode" dense
                                                     :date="showInfo.startDate"
                                                     label="Start Date*" class="mr-1"
                                                     v-on:updateDates="updateDates($event, 'startDate')" />
                            </v-col>
                            <v-col>
                                <DatepickerFormatted :disabled="!isEditMode"
                                                     :date="showInfo.endDate"
                                                     label="End Date*" class="mr-1"
                                                     v-on:updateDates="updateDates($event, 'endDate')" />
                            </v-col>

                        </v-row>
                        <v-row class="mb-5">
                            <v-col>
                                <v-select :items="showTypes"
                                          :item-text="item =>item.showTypeId +': '+ item.description"
                                          label="Show Type*"
                                          item-value="showTypeId"
                                          v-model="selectedShowTypeId"
                                          :disabled="!isEditMode"
                                          :rules="[(v) => !!v || 'Show Type is required',]">
                                </v-select>

                            </v-col>
                            <v-col>
                                <DatepickerFormatted :disabled="!isEditMode"
                                                     :date="showInfo.postMarkDate"
                                                     label="Postmark Date" class="mr-1"
                                                     v-on:updateDates="updateDates($event, 'postMarkDate')" />


                            </v-col>
                        </v-row>

                    </v-card-text>
                   
                </v-card>

            </v-col>

        </v-row>

        <div v-if="badShowData">

            <v-row>
                <v-col>
                    <v-card elevation="2">
                        <v-card-title class="text-h6">
                            Affiliate
                        </v-card-title>

                        <v-card-text>
                            <v-row v-if="showInfo.clubId">
                                <v-col>
                                    Affiliate ID: {{showInfo.clubId}} <br />
                                    S&amp;T Notes: {{showInfo.newletterNotes}}
                                    <br /><br />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <span class="red-text">
                                        This show is missing required data
                                        <br />
                                    </span>
                                </v-col>
                            </v-row>


                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </div>

        <div v-else>
            <v-row>
                <v-col>
                    <v-card elevation="2">
                        <v-card-title class="text-h6">
                            Affiliate
                            <v-btn class="ml-1 text-xs" v-on:click="reloadAffiliate()" v-if="showInfo.clubId && isEditMode" color="primary">
                                <v-icon> mdi-refresh </v-icon>
                            </v-btn>

                            <v-btn class="ml-1 text-xs" v-on:click="toggleAffiliateSearch" v-if="isEditMode" color="primary">
                                <v-icon> mdi-magnify </v-icon>
                                Search
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-row v-if="showInfo.clubId">
                                <v-col cols="8">
                                    <span class="">Details</span>
                                    <v-divider class="my-3"></v-divider>
                                    <span class="text-h6 mb-3">
                                        <a v-if="showInfo.sponsoringAffiliate.affiliateId" :href="`/admin/affiliates/${showInfo.sponsoringAffiliate.affiliateId}`"
                                           target="_blank" style="text-decoration: none; color: inherit;">
                                            {{showInfo.sponsoringAffiliate.affiliateId}}: {{showInfo.sponsoringAffiliate.affiliateName}}
                                        </a>
                                        <br />
                                    </span>

                                    Home State: {{showInfo.sponsoringAffiliate.homeState}} <br /><br />

                                    <span class="mt-3 text-lg"><strong>Show Coordinator*</strong></span> <br />
                                    <v-divider class="my-3"></v-divider>
                                    <div v-if="!showInfo.showCoordinator.memberId && showCoordList.length==0" class="text-warning">

                                        <span class="red-text">
                                            Add Show Coordinators to proceed
                                            <a v-if="showInfo.sponsoringAffiliate.affiliateId" :href="`/admin/affiliates/${showInfo.sponsoringAffiliate.affiliateId}`"
                                               target="_blank" style="text-decoration: none; color: inherit;">
                                                <font-awesome-icon icon="arrow-circle-right" color="blue" />
                                            </a>

                                        </span>

                                        <br /><br />
                                    </div>
                                    <div v-else>
                                        <span v-if="showInfo.showCoordinator.memberId">
                                            <v-tooltip dark right>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <font-awesome-icon icon="id-badge"
                                                                       :color="isMemberOfAffiliate(showInfo.showCoordinator.memberId) == false ? 'orange': 'green'"
                                                                       v-bind="attrs"
                                                                       v-on="on" />
                                                </template>
                                                <span>{{ isMemberOfAffiliate(showInfo.showCoordinator.memberId)== false ? "Not an Affiliate Member" : "Affiliate Member"  }}</span>
                                            </v-tooltip>
                                          
                                            <a :href="`/admin/people/${showInfo.showCoordinator.personId}`"
                                               target="_blank" style="text-decoration: none; color: inherit;">
                                                {{showInfo.showCoordinator.memberId}}: {{showInfo.showCoordinator.firstName}} {{showInfo.showCoordinator.lastName}}
                                            </a>

                                            <br /><br />
                                        </span>
                                        <span v-if="!showInfo.showCoordinatorId && showCoordList.length == 0">
                                            <span class="red-text">
                                                Add Show Coordinators to proceed
                                                <a v-if="showInfo.sponsoringAffiliate.affiliateId" :href="`/admin/affiliates/${showInfo.sponsoringAffiliate.affiliateId}`"
                                                   target="_blank" style="text-decoration: none; color: inherit;">
                                                    <font-awesome-icon icon="arrow-circle-right" color="blue" />
                                                </a>
                                            </span>
                                            <br /><br />
                                        </span>
                                        <span v-if="!showInfo.showCoordinator && showCoordList.length > 1">Please select a Show Coordinator <br /><br /></span>
                                        <div v-if="showCoordList.length > 0">
                                            <span v-if="showInfo.showCoordinator != null && showCoordList.length==1 && showCoordList[0].personId == showInfo.showCoordinator.personId"></span>
                                            <span v-else>
                                                <v-row v-if="isEditMode">
                                                    <v-col>
                                                        <v-select :items="showCoordList"
                                                                  :item-text="item => item.memberId +': '+ item.name"
                                                                  class="form-text"
                                                                  outlined
                                                                  dense
                                                                  label="Available Show Coordinators"
                                                                  item-value="personId"
                                                                  v-model="selectedShowCoordId">
                                                        </v-select>
                                                    </v-col>
                                                    <v-col>
                                                        <v-btn class="text-xs" v-on:click="updateShowCoord" :disabled="!isEditMode" color="primary">
                                                            <v-icon>mdi-plus</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>


                                                <br />
                                            </span>

                                        </div>
                                    </div>
                                    <span class="mt-3 text-lg">
                                        <strong>Show Secretary*</strong>
                                        <span v-if="isEditMode">
                                            <v-btn class="ml-1 mr-1"
                                                   :disabled="!isEditMode"
                                                   color="primary"
                                                   @click="togglePersonSearch(2)">
                                                <font-awesome-icon icon="search" />
                                            </v-btn>
                                        </span>
                                    </span> <br />
                                    <v-divider class="my-3"></v-divider>
                                    <span v-if="showInfo.showSecretary.memberId">
                                        <v-tooltip dark right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <font-awesome-icon icon="id-badge"
                                                                   :color="isMemberOfAffiliate(showInfo.showSecretary.memberId) == false ? 'orange': 'green'"
                                                                   v-bind="attrs"
                                                                   v-on="on" />
                                            </template>
                                            <span>{{ isMemberOfAffiliate(showInfo.showSecretary.memberId) == false ? "Not an Affiliate Member" : "Affiliate Member" }}</span>
                                        </v-tooltip>
                                        <a :href="`/admin/people/${showInfo.showSecretary.personId}`"
                                           target="_blank" style="text-decoration: none; color: inherit;">
                                            {{showInfo.showSecretary.memberId }} : {{showInfo.showSecretary.name}}
                                        </a>
                                        <br /><br />
                                    </span>
                                    <span v-else>
                                        <span v-if="showInfo.showSecretary.personId && showInfo.showSecretary.name">
                                            <v-tooltip dark right>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <font-awesome-icon icon="id-badge" color="orange" v-bind="attrs"
                                                                       v-on="on" />
                                                </template>
                                                <span>{{ "Not an Affiliate Member" }}</span>
                                            </v-tooltip>
                                            <a :href="`/admin/people/${showInfo.showSecretary.personId}`"
                                               target="_blank" style="text-decoration: none; color: inherit;">
                                                {{showInfo.showSecretary.name}}
                                            </a>
                                            <br /><br />
                                        </span>
                                    </span>

                                </v-col>
                                <v-col cols="4">
                                    <span>Conformation Point Schedule</span>
                                    <v-divider class="my-3"></v-divider>
                                    <v-select v-model="showInfo.dogSched"
                                              :items="pointScheduleIds" outlined dense
                                              label="Dog Sched" clearable class="form-text mr-1"
                                              :disabled="!isEditMode"></v-select>
                                    <v-select v-model="showInfo.altDogSched"
                                              :items="pointScheduleIds" outlined dense
                                              label="Alt Dog Sched" clearable class="form-text mr-1"
                                              :disabled="!isEditMode"></v-select>
                                    <v-select v-model="showInfo.bitchSched"
                                              :items="pointScheduleIds"
                                              label="Bitch Sched" clearable dense class="form-text mr-1"
                                              :disabled="!isEditMode" outlined></v-select>
                                    <v-select v-model="showInfo.altBitchSched"
                                              :items="pointScheduleIds" outlined dense
                                              label="Alt Bitch Sched" clearable class="form-text mr-1"
                                              :disabled="!isEditMode"></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="showInfo.clubId">
                                <v-col>
                                    <v-text-field v-model="showInfo.newsletterNotes"
                                                  :disabled="!isEditMode" class="mr-1 form-text"
                                                  label="S&T Notes" :rules="[v => (v || '' ).length <= 100 || 'Limited to 100 chars']"
                                                  outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="pa-2" elevation="2">
                        <v-card-title class="text-h6">
                            Show Location
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-text-field v-model="showInfo.location"
                                              :disabled="!isEditMode" class="ml-3 form-text"
                                              label="Preferred" dense
                                              :rules="[v => (v || '' ).length <= 50 || 'Limited to 50 chars']"
                                              outlined></v-text-field>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="showInfo.showCity"
                                                  :disabled="!isEditMode" class="mr-1 form-text"
                                                  label="City*" :rules="[(v) => !!v || 'City is required',v => (v || '' ).length <= 50 || 'Limited to 50 chars']"
                                                  outlined dense></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="showInfo.showState"
                                                  :disabled="!isEditMode" class="mr-1 form-text"
                                                  label="State*" :rules="[(v) => !!v || 'State is required',v => (v || '' ).length <= 2 || 'Limited to 2 chars']"
                                                  outlined dense></v-text-field>
                                </v-col>


                            </v-row>
                            <v-row>

                                <v-col>
                                    <v-text-field v-model="showInfo.international"
                                                  :disabled="!isEditMode" class="mr-1 form-text"
                                                  label="Int'l Area'" :rules="[v => (v || '' ).length <= 50 || 'Limited to 50 chars']"
                                                  outlined dense></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="showInfo.showCountry"
                                                  :disabled="!isEditMode" class="mr-1 form-text"
                                                  label="Country" :rules="[v => (v || '' ).length <= 50 || 'Limited to 50 chars']"
                                                  outlined dense></v-text-field>
                                </v-col>

                            </v-row>


                        </v-card-text>


                    </v-card>

                </v-col>


            </v-row>

            <div class="mt-3">
                <v-row>
                    <v-col>
                        <v-card class="pa-2" elevation="2">
                            <v-card-title class="text-h6">
                                Judge Schedules
                            </v-card-title>

                            <v-data-table dense class="elevation-1"
                                          :headers="judgeScheduleHeaders"
                                          :items="showInfo.judgeSchedules"
                                          :items-per-page="5">

                                <template v-slot:[`item.startDate`]="{ item }">
                                    <localized-date v-if="item.startDate" :date="item.startDate" />

                                </template>
                                <template v-slot:[`item.endDate`]="{ item }">
                                    <localized-date v-if="item.endDate" :date="item.endDate" />

                                </template>

                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog"
                                                  max-width="800px">
                                            <v-overlay :value="isLoading">
                                                <v-progress-circular indeterminate
                                                                     color="primary"
                                                                     :size="70"
                                                                     :width="7"></v-progress-circular>
                                            </v-overlay>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="primary"
                                                       dark dense
                                                       :disabled="!isEditMode"
                                                       class="mb-2"
                                                       v-bind="attrs"
                                                       v-on:click="initializeJudgeItem">
                                                    Add Judge Schedule
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="text-h5">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <v-container>
                                                        <v-form v-model="isValid">
                                                            <v-alert width="100%" class="pr-2 pl-2" v-if="judgeErrorMessage" type="error"> {{ judgeErrorMessage }}</v-alert>
                                                            
                                                            <v-card v-if="editedIndex === -1 && !editedItem.judgeId" class="mb-3">
                                                                <v-card-text>
                                                                    
                                                                    <v-row>
                                                                        <v-col>
                                                                            <v-text-field class="form-text"
                                                                                          outlined
                                                                                          dense
                                                                                          v-model="searchParamsJudge.judgeId"
                                                                                          label="Judge ID" />
                                                                        </v-col>
                                                                        <v-col>
                                                                            <v-text-field outlined dense class="form-text"
                                                                                          v-model="searchParamsJudge.memberId"
                                                                                          label="Member ID" />
                                                                        </v-col>
                                                                        <v-col>
                                                                            <v-text-field outlined dense class="form-text"
                                                                                          v-model="searchParamsJudge.name"
                                                                                          label="Name" />
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col>
                                                                            <v-checkbox v-model="searchParamsJudge.activeMembersOnly"
                                                                                        label="Show Active Only" dense class="form-text">

                                                                            </v-checkbox>
                                                                        </v-col>
                                                                        <v-col></v-col>
                                                                        <v-col>
                                                                            <v-btn class="ml-1 text-xs" v-on:click="searchJudge" color="primary">
                                                                                <v-icon> mdi-magnify </v-icon>
                                                                                Search
                                                                            </v-btn>
                                                                        </v-col>
                                                                    </v-row>
                                                                    <p v-if="searchJudgeResults.totalCount == 0 && hasSearchJudge">
                                                                        No Matches Found
                                                                    </p>
                                                                
                                                                    <v-data-table v-if="searchJudgeResults.totalCount > 0"
                                                                                  :headers="searchJudgeHeaders"
                                                                                  :items="searchJudgeResults.data"
                                                                                  hide-default-footer>

                                                                        <template v-slot:item="row">

                                                                            <tr>
                                                                                <td>
                                                                                    <a :href="`/admin/judges/${row.item.judgeId}`" target="_blank" v-if="row.item.judgeId">
                                                                                        {{row.item.judgeId}}
                                                                                    </a>
                                                                                </td>
                                                                                <td>
                                                                                    <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                                                                        {{row.item.memberId}}
                                                                                    </a>

                                                                                </td>
                                                                                <td>
                                                                                    <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                                                                        {{ row.item.name }}
                                                                                    </a>
                                                                                </td>
                                                                                <td>
                                                                                    <font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                                                                                </td>
                                                                                <td>
                                                                                    {{row.item.approvedShowIds}}
                                                                                </td>
                                                                                <td>
                                                                                    <v-btn class="ml-1 mr-1"
                                                                                           color="primary"
                                                                                           @click="judgeSelect(row.item)">
                                                                                        <v-icon>mdi-plus</v-icon>
                                                                                    </v-btn>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                    </v-data-table>
                                                                </v-card-text>
                                                            </v-card>

                                                            <div v-if="editedItem.judgeId">
                                                                <v-row v-if="editedItem.judgeId">
                                                                    <v-col class="mb-3">
                                                                        <v-text-field class="form-text"
                                                                                      outlined :disabled="true"
                                                                                      dense :rules="[(v) => !!v || 'Judge is required',]"
                                                                                      v-model="editedItem.judgeId"
                                                                                      label="Judge ID" />
                                                                    </v-col>
                                                                    <v-col>
                                                                        <v-text-field class="form-text"
                                                                                      outlined :disabled="true"
                                                                                      dense
                                                                                      v-model="editedItem.firstName"
                                                                                      label="First Name" />
                                                                    </v-col>
                                                                    <v-col>
                                                                        <v-text-field class="form-text"
                                                                                      outlined :disabled="true"
                                                                                      dense
                                                                                      v-model="editedItem.lastName"
                                                                                      label="Last Name" />
                                                                    </v-col>
                                                                   
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-select :items="showTypes" dense class="form-text"
                                                                                  :item-text="item => item.showTypeId +': '+ item.description"
                                                                                  label="Show Type*"
                                                                                  item-value="showTypeId"
                                                                                  v-model="editedItem.showTypeId"
                                                                                  :disabled="!isEditMode"
                                                                                  :rules="[(v) => !!v || 'Show Type is required',]">
                                                                        </v-select>

                                                                    </v-col>
                                                                </v-row>
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-text-field outlined dense class="form-text"
                                                                                      v-model="editedItem.category"
                                                                                      :rules="[v => (v || '' ).length <= 400 || 'Limited to 400 chars']"
                                                                                      label="Category" />
                                                                    </v-col>


                                                                </v-row>


                                                                <v-row>
                                                                    <v-col>
                                                                        <datepickerFormatted :formattedDate="editedItem.startDateFormatted"
                                                                                             :date="editedItem.startDate"
                                                                                             label="Start Date" dense class="form-text"
                                                                                             v-on:updateDates="updateEditedItemDates($event, 'startDate')" />
                                                                    </v-col>
                                                                    <v-col>
                                                                        <datepickerFormatted :formattedDate="editedItem.endDateFormatted"
                                                                                             :date="editedItem.endDate"
                                                                                             label="End Date" dense class="form-text"
                                                                                             v-on:updateDates="updateEditedItemDates($event, 'endDate')" />


                                                                    </v-col>
                                                                    <v-col cols="4">
                                                                        <v-text-field outlined dense class="form-text ml-2"
                                                                                      v-model="editedItem.time" :rules="[v => (v || '' ).length <= 2 || 'Limited to 2 chars']"
                                                                                      label="Time (AM/PM, 1-5)" />
                                                                    </v-col>
                                                                </v-row>
                                                            </div>

                                                        </v-form>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1"
                                                           text
                                                           @click="close">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn color="blue darken-1"
                                                           text
                                                           :disabled="!editedItem.judgeId"
                                                           @click="save">
                                                        Add/Update
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <v-dialog v-model="dialogDelete" max-width="500px">
                                            <v-card>
                                                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                                    <v-spacer></v-spacer>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small v-if="isEditMode"
                                            class="mr-2"
                                            @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small v-if="isEditMode"
                                            @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div class="mt-3">
            <v-row class="pt-0 mt-0">
                <v-col>
                    <h3>Notes</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-textarea disabled
                            @input="updateText('notes', $event)"
                            :value="showInfo.notes"
                            outlined
                            rows="1"
                            auto-grow></v-textarea>
            </v-row>
        </div>
        <v-snackbar v-model="showInfoMessage" title color="green">
            {{ infoMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showInfoMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="showErrorMessage" title color="red">
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>   
    </v-card>
</template>
<script lang="ts">
import Vue from "vue";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";

import showService from "@/services/admin/showService";
import affiliateService from "@/services/admin/affiliateService";
import { getAscaToday, isDateBefore } from "@/helpers/date-utils";

import { Messages } from "@/constants";
import { UserInfo } from "@/types/User";
import { PaginatedResponse } from "@/types/Pagination";
import { ShowInfo, ShowType, ShowAffiliateInfo, ShowPerson, JudgeScheduleInfo, PointSchedule } from '@/types/admin/Show';

export default Vue.extend({
    name: "ShowEntry",
    components: {
        DatepickerFormatted,
    },
    data: function () {
        return {
            tab: null,
            badShowData: false,
            showInfo: {
                showId: "",
                clubId: "",
                showType: {} as ShowType,
                showCoordinator: {} as ShowPerson,
                showSecretary: {} as ShowPerson,
                sponsoringAffiliate: {} as ShowAffiliateInfo,
                judgeSchedules: [] as JudgeScheduleInfo[],
            } as ShowInfo,
            pointSchedules: [] as PointSchedule[],
            pointScheduleIds: [] as any[],
            isEditMode: false,
            isValid:true,
            showValidationDialog: false,
            validationResult: {
                warnings: [],
                errors: []
            } as any,
            reloadPage: false,
            showTypes: [] as ShowType[],
            showTypeDescriptions: [] as string[],
            showTypeIds: [] as string[],
            searchAffiliateDialog: false,
            searchAffiliatesHeaders: [
                { text: "Affiliate ID", align: "left", value: "affiliateId" },
                { text: "Affiliate Name", align: "left", value: "affiliateName" },
                { text: "Home State", align: "left", value: "state" },
                { text: "Active", align: "left", value: "isActive" },
            ],
            searchPersonHeaders: [
                { text: "Judge ID", align: "center", value: "judgeId" },
                { text: "Member ID", align: "center", value: "memberId" },
                { text: "Name", align: "center", value: "name" },
                { text: "Active", align: "center", value: "isActiveMember" },
                { text: "", align: "center", value: "" },
            ],
            timeOptions: ["",
                "AM", "PM"
            ],
            isLoading: false,
            hasSearchAffiliates: false,
            searchAffiliateResults: {} as PaginatedResponse<object>,
            searchParamsAffiliate: {
                pageSize: 20,
                page: 1,
                ascending: false,
                affiliateId: "",
                affiliateName: "",
                state: "",
                affiliateRep: "",
                membershipStatus: true as any,
            },
            searchParamsPerson: {
                pageSize: 20,
                page: 0,
                ascending: false,
                memberId: "",
                name: "",
                judgeId: "",
                activeMembersOnly: true,
                affiliateId:"",
            },
            applyPointSchedule:true,
            isErrorAffiliate: false,
            searchPersonDialog: false,
            searchPersonResults: Array<object>(),
            selectedShowPerson: -1,
            hasSearchPerson: false,
            allowShowCoordSearch: false,
            showCoordList: [] as any[],
            selectedShowCoordId: -1,
            selectedShowTypeId: "",
            //Judge Related
            searchJudgeHeaders: [
                { text: "Judge ID", align: "center", value: "judgeId" },
                { text: "Member ID", align: "center", value: "memberId" },
                { text: "Name", align: "center", value: "name" },
                { text: "Active", align: "center", value: "isActiveMember" },
                { text: "Quals", align: "center", value: "judgeQuals" },
                { text: "", align: "center", value: "" },

            ],
            judgeScheduleHeaders: [
                { text: "Judge ID", align: "left", value: "judgeId" },
                { text: "Name", align: "left", value: "name" },
                { text: "Start Date", align: "left", value: "startDate" },
                { text: "End Date", align: "left", value: "endDate" },
                { text: "Type ID", align: "left", value: "showTypeId" },
                { text: "Time", align: "left", value: "time" },
                { text: "Category", align: "left", value: "category" },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            selectedJudgeShowTypeId: "",
            searchJudgeResults: Array<object>(),
            searchParamsJudge: {
                pageSize: 20,
                page: 1,
                ascending: false,
                memberId: "",
                name: "",
                judgeId: "",
                activeMembersOnly: false,
                affiliateId: "",
                showTypeId: "",
            },
            editedIndex: -1,
            editedItem: {} as JudgeScheduleInfo,
            defaultItem: {} as JudgeScheduleInfo,
            dialog: false,
            dialogDelete: false,
            hasSearchJudge: false,
            judgeErrorMessage : "",
            errorMessage: '',
            infoMessage: '',
            showErrorMessage: false,
            showInfoMessage: false
        };
    },
    methods: {
        isExpired(date: Temporal.PlainDate) {
            return isDateBefore(date, getAscaToday());
        },
        reloadData: function () {
            this.badShowData = false;
            this.errorMessage = '';
            this.showErrorMessage = false;
            
            if (this.showId) {
                showService
                    .getShowById(this.showId)
                    .then((res) => {
                        this.showInfo = res;
                        this.showCoordList = res.affiliateShowCoords;
                        this.selectedShowTypeId = this.showInfo.showTypeId;
                        this.selectedJudgeShowTypeId = this.showInfo.showTypeId;
                        this.editedItem.startDate = this.showInfo.startDate;
                        this.editedItem.endDate = this.showInfo.endDate;
                        this.editedItem.showTypeId = this.showInfo.showTypeId;
                        if (this.showInfo.showCoordinatorId == null || this.showInfo.showSecretaryId == null) {
                            this.badShowData = true;
                        }
                    }).catch(e => {
                        this.initializeNewShow();
                        this.isEditMode = true;
                    });
            }
            else {
                this.initializeNewShow();
                this.isEditMode = true;
                this.reloadPage = true;
                this.allowShowCoordSearch = false;
                this.judgeErrorMessage = "";
            }
        },
        initializeNewShow() {
            this.showInfo = {
                showId: "",
                clubId: "",
                showTypeId: "",
                showCity: "",
                showState: "",
                showCountry: "",
                location: "",
                international: "",
                newsletterNotes: "",
                notes: "",
                showType: {} as ShowType,
                showCoordinator: {
                    personId: -1,
                    memberId: "",
                    name: "",
                    firstName: "",
                    lastName: "",
                } as ShowPerson,
                showSecretary: {
                    personId: -1,
                    memberId: "",
                    name: "",
                    firstName: "",
                    lastName: "",
                } as ShowPerson,
                sponsoringAffiliate: {
                    affiliateId: "",
                    affiliateName: "",
                    homeState: "",
                } as ShowAffiliateInfo,
                judgeSchedules: [] as JudgeScheduleInfo[],
            } as ShowInfo;
        },
        isValidNumber(value: string) {
            if (!value) {
                return true;
            }
            if (!isNaN(parseFloat(value))) return true;
            return 'Must be valid number';
        },
        toggleEditMode: function () {
            if (this.isEditMode) {
                this.validateAndConfirmSavingChanges();
            }

            this.isEditMode = !this.isEditMode;
        },
        updateDates: function (val: any, key: string) {
            this.$data.showInfo[key] = val?.date;
            this.$data.showInfo = Object.assign({}, this.$data.showInfo);
        },
        updateText: function (key: string, event: string) {
            this.$data.showInfo[key] = event;
        },
        updateAndValidateDataEntry: function () {
        this.errorMessage = "";
        this.showErrorMessage = false;

            if (this.showInfo.startDate == null || this.showInfo.endDate == null) {
                this.errorMessage = "Start and End Dates are required."
            this.showErrorMessage = true;
                return false;
            }
            if (this.selectedShowTypeId == null || this.selectedShowTypeId == "") {
                this.errorMessage = "Show Type is required.";
                this.showErrorMessage = true;
                return false;
            }
            else {
                this.showInfo.showTypeId = this.selectedShowTypeId;
            }
            if (this.showInfo.clubId == null || this.showInfo.clubId == "") {
                this.errorMessage = "Sponsoring Affiliate is required.";
                this.showErrorMessage = true;
                return false;
            }
            if (this.showInfo.showSecretaryId == null || this.showInfo.showCoordinatorId == null) {
                this.errorMessage = "Show Coordinator and Secretary are required.";
                this.showErrorMessage = true;
                return false;
            }

            if (this.showInfo.showCity == null || this.showInfo.showCity.length < 2) {
                this.errorMessage = "City is required.";
                this.showErrorMessage = true;
                return false;
            } else if (this.showInfo.showCity.length > 50) {
                this.errorMessage = "City is too long.";
                this.showErrorMessage = true;
                return false;
            }

            if (this.showInfo.showState == null || this.showInfo.showState.length < 2) {
                this.errorMessage = "State is required.";
                this.showErrorMessage = true;
                return false;
            } else if (this.showInfo.showState.length > 2) {
                this.errorMessage = "State is too long.";
                this.showErrorMessage = true;
                return false;
            }

            if (this.showInfo.showCountry != null && this.showInfo.showCountry.length > 50) {
                this.errorMessage = "Country is too long.";
                this.showErrorMessage = true;
                return false;

            }
            if (this.showInfo.newsletterNotes != null && this.showInfo.newsletterNotes.length > 100) {
                this.errorMessage = "S & T Note is too long.";
                this.showErrorMessage = true;
                return false;
            }

            return true;
        },
        validateAndConfirmSavingChanges: function () {
            if (this.updateAndValidateDataEntry()) {
                showService
                    .validateShowEdit(this.showInfo)
                    .then((res: any) => {
                        this.validationResult = res;
                        if (this.validationResult.errors.length > 0 || this.validationResult.warnings.length > 0) {
                            this.showValidationDialog = true;
                        }
                        else {
                            this.saveChanges();
                            this.validationResult = {};
                        }
                    })
            }
            else {
                this.isEditMode = false; //will toggle it back to edit mode
            }
        },
        saveChanges: function () {
            this.errorMessage = "";
            this.showErrorMessage = false;

            this.showValidationDialog = false;
            this.$store.dispatch("changeLoaderStatus", true);
            showService
                .editShowDetails(this.showInfo)
                .then((res) => {
                    if (res.success) {
                        if (res.id && res.id != this.$props.showId) {
                            this.$router.push({ path: `/admin/shows/${res.id}` }).catch(this.$handleNavigationError);
                        }
                        this.reloadData();
                        this.isEditMode = false;
                        this.infoMessage = Messages.SaveSuccessful;
                        this.showInfoMessage = true;
                    } else {         
                        if (res.messages != null) {     
                            this.errorMessage = Messages.SaveError + " " + res.messages.join(', ');
                            this.showErrorMessage = true;
                        }
                        else {
                            this.errorMessage = "Unable to process show create/edit at this time.";
                            this.showErrorMessage = true;
                        }
                    }
                })
                .catch((e) => {                  
                this.errorMessage = Messages.SaveError;
                this.showErrorMessage = true;
                })
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));
            
        },
        //Affiliate
        toggleAffiliateSearch: function () {
            this.searchAffiliateDialog = !this.searchAffiliateDialog;
        },
        affiliateSelect: function (row: any) {
            this.searchAffiliateDialog = false;
            if (row.affiliateId) {
                affiliateService
                    .getShowAffiliateById(row.affiliateId)
                    .then((res) => {
                        this.showInfo.sponsoringAffiliate = res;
                        this.showInfo.clubId = row.affiliateId;
                        if (this.applyPointSchedule) {
                            this.updatePointSchedule();
                        }
                        this.updateShowCoordList(row.affiliateId);
                    }).catch(() => {
                        this.errorMessage = "Unable to retrieve Affiliate Information.";
                        this.showErrorMessage = true;
                    });
            }
        },
        reloadAffiliate: function () {
            affiliateService
                .getShowAffiliateById(this.showInfo.clubId)
                .then((res) => {
                    this.showInfo.sponsoringAffiliate = res;
                    this.updateShowCoordList(this.showInfo.clubId);
                }).catch(() => {
                    this.errorMessage = "Unable to retrieve Affiliate Information.";
                    this.showErrorMessage = true;
                });
        },
        clearSearchAffiliate: function () {
            this.searchAffiliateResults = {} as PaginatedResponse<object>;
        },
        updateShowCoord: function () {
            if (this.selectedShowCoordId == null) {
                return false;
            }
            this.showInfo.showCoordinatorId = this.selectedShowCoordId;
            this.showInfo.showCoordinator = this.showCoordList.find((x: ShowPerson) => x.personId == this.selectedShowCoordId);
            return true;
        },
        searchAffiliate: function (fromPagination?: boolean) {
            if (fromPagination !== true) this.searchParamsAffiliate.page = 1;
            this.isLoading = true;
            this.hasSearchAffiliates = false;
            if(this.searchParamsAffiliate.membershipStatus == false) {
                this.searchParamsAffiliate.membershipStatus = null;
            }
            affiliateService
                .getAffiliatesList({
                    page: 0,
                    itemsPerPage: 20,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false,
                }, this.searchParamsAffiliate)
                .then((res) => {
                    this.searchAffiliateResults = res;
                    this.hasSearchAffiliates = true;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.errorMessage = "Unable to search for Affiliates";
                    this.showErrorMessage = true;
                    return;
                });
            this.isLoading = false;
        },
        updatePointSchedule: function () {
            if (this.showInfo.sponsoringAffiliate != null) {
                this.showInfo.dogSched = this.showInfo.sponsoringAffiliate.dogSched;
                this.showInfo.altBitchSched = this.showInfo.sponsoringAffiliate.altBitchSched;
                this.showInfo.altDogSched = this.showInfo.sponsoringAffiliate.altDogSched;
                this.showInfo.bitchSched = this.showInfo.sponsoringAffiliate.bitchSched;
            }
        },
        updateShowCoordList: function (affiliateId: string) {
            this.showCoordList = [] as any[];
            affiliateService.getAffiliateShowCoordinators(affiliateId).then((res: any) => {
                this.showCoordList = res;
                //if there is only one show coord to choose from and this is a new show, choose it.
                //They can still update the club, and do a refresh to pull more choices
                if (this.showCoordList.length == 1 && (!this.showId || !this.showInfo.showCoordinatorId)) {
                    this.showInfo.showCoordinatorId = this.showCoordList[0].personId;
                    this.showInfo.showCoordinator = {
                        personId: this.showCoordList[0].personId,
                        memberId: this.showCoordList[0].memberId,
                        active: this.showCoordList[0].active,
                        name: this.showCoordList[0].name,
                        firstName: this.showCoordList[0].firstName,
                        lastName: this.showCoordList[0].lastName,
                    };
                }
            });
        },
        isMemberOfAffiliate: function (memberId: String) {
            if (!this.showInfo || memberId == null) {
                return false;
            }
            if (this.showInfo.sponsoringAffiliate == null
                || this.showInfo.sponsoringAffiliate.members == null
                || this.showInfo.sponsoringAffiliate.members.length == 0) {
                return false;
            }
            var member = this.showInfo.sponsoringAffiliate.members.find((x: any) => x.memberId.trim() == memberId.trim());
            if (member != null) {
                return true;
            }
            return false;
        },
        //People Search
        searchPerson: function (fromPagination?: boolean) {
            this.searchPersonResults= Array<object>();
            if (fromPagination !== true) this.searchParamsPerson.page = 0;
            this.isLoading = true;
            this.hasSearchPerson = false;
            this.searchParamsPerson.affiliateId = this.showInfo.sponsoringAffiliate.affiliateId;
            showService
                .getShowPeopleList(this.searchParamsPerson)
                .then((res) => {
                    this.searchPersonResults = res;
                    this.hasSearchPerson = true;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.errorMessage = "Unable to search for Show Person";
                    this.showErrorMessage = true;
                    return;
                });
            this.isLoading = false;
        },
        togglePersonSearch: function (forPerson: number) {
            this.selectedShowPerson = forPerson;
            this.$data.searchPersonDialog = !this.$data.searchPersonDialog;
        },
        clearSearchPerson: function () {
            this.searchParamsPerson = {
                pageSize: 20,
                page: 1,
                ascending: false,
                memberId: "",
                name: "",
                judgeId: "",
                activeMembersOnly: true,
                affiliateId: "",
            };
            this.searchPersonResults = Array<object>();
        },
        personSelect: function (row: any) {
            this.searchPersonDialog = false;
            if (row.personId != null) {
                this.showInfo.showSecretaryId = row.personId;
                this.showInfo.showSecretary = {
                    personId: row.personId,
                    memberId: row.memberId,
                    active: row.active,
                    name: row.name,
                    firstName: row.firstName,
                    lastName: row.lastName,
                };
                if (row.name != null) {
                    this.showInfo.showSecretaryName = row.name;
                }
                else {
                    this.showInfo.showSecretaryName = row.firstName + ' ' + row.lastName;
                }
            }
        },
        //Judge Schedules
        reloadShowTypes: function () {
            showService.getJudgeShowTypes().then((res: any) => {
                this.showTypes = res;
                for (let i = 0; i < this.showTypes.length; i++) {
                    this.showTypeDescriptions.push(this.showTypes[i].description);
                    this.showTypeIds.push(this.showTypes[i].showTypeId);
                }
            });
        },
        searchJudge: function (fromPagination?: boolean) {
            this.searchJudgeResults = Array<object>();
            if (fromPagination !== true) this.searchParamsJudge.page = 1;
            this.isLoading = true;
            this.hasSearchJudge = false;
            
            showService
                .getShowJudgesList(this.searchParamsJudge)
                .then((res) => {
                    this.searchJudgeResults = res;
                    this.hasSearchJudge = true;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.errorMessage = "Unable to search for Judge";
                    this.showErrorMessage = true;
                    return;
                });
            this.isLoading = false;
        },
        judgeSelect: function (row: any) {
            this.judgeErrorMessage = "";
            if (row.judgeId != null) {
                this.editedItem.personId = row.personId;
                this.editedItem.judgeId = row.judgeId;
                this.editedItem.memberId = row.memberId;
                this.editedItem.firstName = row.firstName;
                this.editedItem.lastName = row.lastName;
                this.editedItem.name = row.name;
                this.editedItem.showId = this.showId;
            }

            this.clearJudgeSearch();
        },
        clearJudgeSearch: function () {
            this.searchJudgeResults = [] as any[];
            this.searchParamsJudge = {
                pageSize: 20,
                page: 1,
                ascending: false,
                memberId: "",
                name: "",
                judgeId: "",
                activeMembersOnly: false,
                affiliateId: "",
                showTypeId: "",
            };
        },
        updateJudgeScheduleDates: function (val: any, key: string) {
            this.$data.showInfo.judgingSchedules[key] = val?.date;
            this.$data.showInfo.judgingSchedules = Object.assign({}, this.$data.showInfo.judgingSchedules);
        },
        updateEditedItemDates: function (val: any, key: string) {
            this.$data.editedItem[key] = val?.date;
            this.$data.editedItem = Object.assign({}, this.$data.editedItem);
        },
        editItem(item: JudgeScheduleInfo) {
            this.editedIndex = this.showInfo.judgeSchedules.indexOf(item)
            this.editedItem = Object.assign({}, item)               
            this.dialog = true
        },
        initializeJudgeItem() {
            this.editedItem.startDate = this.showInfo.startDate;
            this.editedItem.endDate = this.showInfo.endDate;
            this.editedItem.showTypeId = this.showInfo.showTypeId;
            this.editedItem.showId = this.showId;
            this.dialog = true;

        },
        deleteItem(item: JudgeScheduleInfo) {
            this.editedIndex = this.showInfo.judgeSchedules.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm() {
            this.showInfo.judgeSchedules.splice(this.editedIndex, 1)
            this.closeDelete()
        },
        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        save() {
            if (this.editedItem.judgeId == null || this.editedItem.judgeId.length == 0) {
                this.errorMessage = "You must select a Judge.";
                
                return;
            }
            if (this.editedItem.category != null && this.editedItem.category.length > 400) {
                this.errorMessage = "Category is too long.";
                return;
            }
            if (this.editedIndex > -1) {
                Object.assign(this.showInfo.judgeSchedules[this.editedIndex], this.editedItem)
            }
            else {
                if (this.showInfo) {
                    this.showInfo.judgeSchedules.push(this.editedItem)
                }
            }
            this.close();
        },
        
    },
    created: function () {
        
        showService.getPointSchedules().then((res: any) => {
            this.pointSchedules = res;
            this.pointScheduleIds.push("");
            for (let i = 0; i < this.pointSchedules.length; i++) {
                this.pointScheduleIds.push(this.pointSchedules[i].pointScheduleId);
            }
        });

        this.reloadShowTypes();
        this.reloadData();

        if (this.showId) {
            if (this.showInfo.affiliateShowCoords && this.showInfo.affiliateShowCoords.length > 0) {
                this.showCoordList = this.showInfo.affiliateShowCoords;
            }
        }
    },
    watch: {
        showId: function (newVal: String) {
            this.reloadData();
        },
        dialog(val) {
            val || this.close()
        },
        dialogDelete(val) {
            val || this.closeDelete()
        },
    },
    props: {
        showId: { type: String },
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
        formTitle() {
            return this.$data.editedIndex === -1 ? "Add Judge" : "Edit Judge";
        },
    },
});
</script>
